<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>消息推送</el-breadcrumb-item>
        <el-breadcrumb-item>消息列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">消息列表</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleToCategory"
          >分类管理</el-button>
          <el-button
            class="button"
            type="primary"
            @click="handleNoticeCreate"
          >添加消息</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="消息标题"
          prop="title"
        >
          <el-input
            v-model="query.title"
            placeholder="输入消息标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="消息分类"
          prop="category_id"
        >
          <el-select
            v-model="query.category_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="消息标题"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="description"
            label="消息描述"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="picture_url"
            label="消息封面"
            min-width="150"
            align="center"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.picture_url"
                style="max-height: 50px;"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="link_url"
            label="消息链接"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="关联内容"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="scope.row.ref_content">{{scope.row.ref_content.name || scope.row.ref_content.title}}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="send_count"
            label="已推送用户数"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="read_count"
            label="已阅读用户数"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="creator"
            label="创建人"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToNoticeEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleToNoticePush(scope.row, scope.$index)"
              >推送</el-button>
              <!-- <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToNoticeRemove(scope.row, scope.$index)">删除</el-button> -->
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToNoticeEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="b"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToNoticePush(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      推送
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <NoticeCreate
      :visible="createDialog"
      @close="createDialog = false"
      @submit="fetchNoticeList"
    ></NoticeCreate>
    <NoticeEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog = false"
      @submit="fetchNoticeList"
    ></NoticeEdit>
  </div>
</template>

<script>
import NoticeCreate from '@/components/dialog/notice/NoticeCreate'
import NoticeEdit from '@/components/dialog/notice/NoticeEdit'
import { noticeList, noticeDestroy, noticeCategoryList } from '@/api/operation'

export default {
  components: {
    NoticeCreate,
    NoticeEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {
        ref_content: {}
      },
      query: {
        title: '',
        type: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      categorys: [],
      results: [],
      types: [
        { label: '全部', value: '' },
        { label: '系统消息', value: 1 },
        { label: '课程通知', value: 2 },
      ],
      isfixed: document.body.clientWidth < 820 ? false : true,
    }
  },
  created() {
    this.parseQuery()
    this.fetchNoticeList()
    this.fetchCategoryList()
    this.$store.dispatch('getAdminList')
  },
  methods: {
    // 分类列表请求
    fetchCategoryList() {
      noticeCategoryList({ status: 1, isPaging: 0 }).then(res => {
        let list = res.list || []
        list.unshift({ id: '', name: '全部' })
        this.categorys = list
      })
    },
    // 消息列表请求
    fetchNoticeList() {
      noticeList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchNoticeList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchNoticeList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchNoticeList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchNoticeList()
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/member/notice/category`)
    },
    // 消息创建
    handleNoticeCreate() {
      this.createDialog = true
    },
    // 消息编辑
    handleToNoticeEdit(row) {
      this.editRow = Object.assign({}, row)
      this.editDialog = true
    },
    // 消息推送
    handleToNoticePush(row) {
      this.$router.push(`/member/notice/${row.id}`)
    },
    // 消息删除
    handleToNoticeRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        noticeDestroy({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchNoticeList()
        })
      }).catch(() => { })
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
